import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { constant } from 'app/modules/common/helpers/constant';
import { map } from 'rxjs/operators';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from '../../common/services/api.service';
import API from '../../common/services/api.config.json';

@Injectable()
export class TemplateService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient) { }


  getTemplates(): Observable<RestResponse> {
    const url = `${API.Maintenance.templates}`;
    return this.apiService.get(url);
  }

  saveNewTemplate(model: any): Observable<RestResponse> {
    return this.http.post(constant.HOME_URL + API.Maintenance.saveTemplate, model).pipe(map((data: any) => {
      if (data.code === 1) {
        throw new Error('Valid token not returned');
      } else {
        return data;
      }
    }));
  }

  deleteTemplate(id: string): Observable<RestResponse> {
    const url = `${API.Maintenance.deleteTemplate}/${id}`;
    return this.apiService.delete(url);
  }

  downloadTemplate(id: string): Observable<RestResponse> {
    let url = `${API.Maintenance.downloadtemplate}`;
    url = url.replace('{templateId}', id);
    return this.apiService.get(url);
  }

}

